// Class: lime._internal.graphics.BlurStack

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;

// Constructor

var BlurStack = function() {
	this.r = 0;
	this.g = 0;
	this.b = 0;
	this.a = 0;
	this.n = null;
}

// Meta

BlurStack.__name__ = "lime._internal.graphics.BlurStack";
BlurStack.__isInterface__ = false;
BlurStack.prototype = {
	
};
BlurStack.prototype.__class__ = BlurStack.prototype.constructor = $hxClasses["lime._internal.graphics.BlurStack"] = BlurStack;

// Init



// Statics




// Export

exports.default = BlurStack;